module.exports = __webpack_public_path__ + "img/sonarqube.d35b97e5.svg";